import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
const info = {
    title: "Label",
    type: "label",
    icon: "h-icon-all-text-t",
    dataItemType: DataItemType.ShortText,
    formControllerType: FormControlType.Label,
    group: "",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
    },
};
